import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../../components/CustomButtons/Button";
import { Link } from "react-router";
import { Delete, Visibility } from "@mui/icons-material";
import { AsyncProductAutocomplete } from "../../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { FormattedNumber } from "react-intl";

export default function Products() {
  const { control, vestiging } = useFormContext();
  const { fields, replace, remove } = useFieldArray({
    control,
    name: "products",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Box sx={{ mb: 4 }}>
          <AddChildProduct fields={fields} replace={replace} />
        </Box>

        {fields.length === 0 ? (
          <TranslationWrapper
            tDefault={
              "No arrangement identifier(s) configured yet. You need to configure at least one for your arrangement to work."
            }
            tKey={"arrangements.arrangement-identifier.warning"}
          />
        ) : (
          <TableContainer
            sx={{
              "& tr:nth-child(even)": {
                backgroundColor: "#eee",
              },
            }}
          >
            <Table size={"small"}>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fields.map((field, index) => {
                  return (
                    <TableRow>
                      <TableCell>
                        <Typography sx={{ color: "#555" }}>#{field.id}</Typography>
                      </TableCell>
                      <TableCell>
                        <FormattedNumber currency={vestiging?.valuta ?? "EUR"} style={"currency"} value={field.prijs} />
                      </TableCell>
                      <TableCell>{field.naam}</TableCell>

                      <TableCell>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>

                        <Link to={`/manager/producten/${field.id}/edit`}>
                          <Tooltip
                            placement={"bottom"}
                            title={
                              <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                            }
                          >
                            <Button color={"success"} simple>
                              <Visibility />
                            </Button>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
}

function AddChildProduct({ replace, fields }) {
  const { menukaartVestigingId } = useFormContext();

  return (
    <AsyncProductAutocomplete
      async_url={`core/arrangementIdentifierProduct/${menukaartVestigingId}`}
      fetchAdapterVariant={"custom-controller"}
      multiple={true}
      onChange={(option) => {
        replace(option);
      }}
      value={fields.map(({ id }) => id)}
    />
  );
}
